import { format } from "date-fns";
import React from "react";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export const Modulecolumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "module", headerName: "Module", flex: 1 },
  { field: "company", headerName: "Company", flex: 1 },
];

export const RightsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "title", headerName: "Title", flex: 1 },
  { field: "icon", headerName: "Icon", flex: 1 },
  { field: "action", headerName: "Action", flex: 1 },
  { field: "module", headerName: "Module", flex: 1 },
];
export const RoleGroupColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "roleGroup", headerName: "Role Group", flex: 1 },
  {
    field: "createdDate",
    headerName: "Start Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
  {
    field: "endDate",
    headerName: "End Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
];

export const CasesColumns = [
  { field: "id", headerName: "ID", flex: 0.2, headerClassName: "header-cell" },
  {
    field: "clientType",
    headerName: "Client Type",
    flex: 1.5,
    headerClassName: "header-cell",
  },
  {
    field: "fileNumber",
    headerName: "File Number",
    flex: 2,
    headerClassName: "header-cell",
    valueGetter: (params) =>
      params.row.fileNumber || params.row.caseNumber || "-",
  },
  {
    field: "title",
    headerName: "Title",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "description",
    headerName: "Description",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "categoryName",
    headerName: "Category Name",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "subcategoryName",
    headerName: "Subcategory Name",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    headerClassName: "header-cell",
  },
  {
    field: "balance",
    headerName: "Balance",
    flex: 1,
    headerClassName: "header-cell",
  },
  {
    field: "caseStatus",
    headerName: "Case Status",
    flex: 1,
    headerClassName: "header-cell",
  },
  {
    field: "isActive",
    headerName: "Active",
    flex: 2,
    headerClassName: "header-cell"
  },

];

export const timeTrackerColumns =
  [
    { field: "id", headerName: "ID", width: 70 },
   // { field: "appliedDate", headerName: "Applied Date", width: 130 },
    { field: "assignee", headerName: "Assignee", width: 150 },

    { field: "billableItem", headerName: "Billable Item", width: 160 },
    { field: "description", headerName: "Description", width: 250 },
    { field: "timeTakenSeconds", headerName: "Time Taken (s)", width: 150 },
    { field: "travelHours", headerName: "Travel Hours", width: 130 },
    { field: "otherHours", headerName: "Other Hours", width: 130 },
    { field: "totalBillableHours", headerName: "Total Billable Hours", width: 160 },
    { field: "ratePerHour", headerName: "Rate / Hour", width: 130 },
    { field: "startTime", headerName: "Start Time", width: 150 },
    { field: "stopTime", headerName: "Stop Time", width: 150 },
    //  { field: "currency", headerName: "Currency", width: 100 },
    // { field: "exchangeRate", headerName: "Exchange Rate", width: 130 },
        { field: "insertedBy", headerName: "Inserted By", width: 130 },
   // { field: "status", headerName: "Status", width: 120 },
   // { field: "createdAt", headerName: "Created At", width: 150 },
   
  ]


export const FileInstructionsColumns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "postDate", headerName: "Post Date", width: 150 },
  { field: "sender", headerName: "Sender", width: 150 },
  { field: "receiver", headerName: "Receiver", width: 150 },
  { field: "details", headerName: "Details", width: 250 },
  { field: "amount", headerName: "Amount", width: 120 },
  { field: "client", headerName: "Client", width: 150 },
  { field: "file", headerName: "File", width: 150 },
  { field: "approvedBy", headerName: "Approved By", width: 150 },
  { field: "status", headerName: "Status", width: 120 },
];

export const TeamAssignmentsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "username", headerName: "Username", flex: 1 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "role", headerName: "Role", flex: 1 },
];

export const FactColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "factDescription", headerName: "Fact Description", flex: 2 },
  {
    field: "court",
    headerName: "Court Name",
    flex: 1,
    valueGetter: (params) => {
      // If court name is returned as 'courtName', use params.row.courtName
      // Otherwise, map courtId to name (e.g., from a lookup)
      return params.row.courtName || `Court ID: ${params.row.courtId}`;
    },
    renderCell: (params) => <span>{params.value}</span>,
  },
  {
    field: "courtDate",
    headerName: "Court Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
];
export const CaseTasksColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "dueDate",
    headerName: "Due Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
  { field: "description", headerName: "Description", flex: 2 },
  { field: "assigneeFirstName", headerName: "Assigned To", flex: 1, },
  { field: "done", headerName: "Status", flex: 1 },
  // { field: "statusFlag", headerName: "Status Flag", flex: 1 },
];

export const CaseEventColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "description", headerName: "Event Description", flex: 2 },
];

export const JudgeAssignmentColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "name", headerName: "Name", flex: 1 },
];

export const DocumentUploadColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "caseTitle", headerName: "Case Title", flex: 1 },
  { field: "caseNumber", headerName: "Case Number", flex: 1 },
  { field: "fileName", headerName: "File Name", flex: 1 },
  // { field: "firstName", headerName: "First Name", flex: 1 },
  // { field: "lastName", headerName: "Last Name", flex: 1 },
  // { field: "roleName", headerName: "Role Name", flex: 1 },
  // { field: "authorId", headerName: "Author ID", flex: 1 },
  // { field: "caseId", headerName: "Case ID", flex: 1 },
  {
    field: "createdDate",
    headerName: "Created Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
  // { field: "lastModifiedDate", headerName: "Last Modified Date", flex: 1 },
  { field: "filePath", headerName: "File Path", flex: 1 },
  // { field: "companyId", headerName: "Company ID", flex: 1 },
  // { field: "deleted", headerName: "Deleted", flex: 1 },
  // { field: "deletedDate", headerName: "Deleted Date", flex: 1 },
  // { field: "company", headerName: "Company", flex: 1 },
];

export const CourtAssignmentsColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "caseNumber", headerName: "Case Number", flex: 1 },
  { field: "caseTitle", headerName: "Case Title", flex: 1 },
  { field: "caseDescription", headerName: "Case Description", flex: 1 },
  { field: "court", headerName: "Court", flex: 1 },
  { field: "subCounty", headerName: "Sub-County", flex: 1 },
  { field: "county", headerName: "County", flex: 1 },
];
export const ClientReceiptColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },

  // Mapped from 'transactionDate' to 'receiptDate'
  {
    field: "receiptDate",
    headerName: "Receipt Date",
    flex: 0.9,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },

  // Mapped from 'client' to 'clientName'
  {
    field: "clientName",
    headerName: "Client",
    flex: 1,
    valueGetter: (params) =>
      params.row?.clientName ||
      params.row?.client?.fullName ||
      params.row?.client?.companyName ||
      "—",
  },

  // --- FIELDS THAT DID NOT CHANGE ---

  { field: "totalAmount", headerName: "Amount", type: "number", flex: 0.8 },

  // Mapped from 'currency' to 'currencyName'
  { field: "currencyName", headerName: "Currency", flex: 1 },

  // Adding the allocation account field from the returnFields
  { field: "accountName", headerName: "Allocated To", flex: 1 },
  {
    field: "isPosted",
    headerName: "Stage",
    flex: 0.8,
    renderCell: (params) => {
      const statusColors = {
        0: { text: "Pending", color: "#FF9800", background: "#FFF3E0" },
        1: { text: "Approved", color: "#4CAF50", background: "#E8F5E9" },
      };

      const status = statusColors[params.value] || {
        text: "Unknown",
        color: "#757575",
        background: "#FAFAFA",
      };

      return (
        <span
          style={{
            color: status.color,
            textTransform: "capitalize",
            fontSize: "0.85rem",
          }}
        >
          {status.text}
        </span>
      );
    },
  },
];

export const CorporateClientsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "companyName", headerName: "Company Name", flex: 1 },
  { field: "contactNumber", headerName: "Contact Number", flex: 1 },
  { field: "email", headerName: "Email", flex: 2 },
  { field: "address", headerName: "Address", flex: 1 },
  { field: "industrySector", headerName: "Industry Sector", flex: 1 },
  { field: "accountBalance", headerName: "Balance", flex: 1 },
];

export const IndividualClientsColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "contactNumber", headerName: "Contact Number", flex: 1 },
  { field: "email", headerName: "Email", flex: 2 },
  { field: "accountBalance", headerName: "Balance", flex: 1 },
];
export const ChargeLinesColumns = [
  { field: "id", headerName: " id", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  { field: "price", headerName: "Price", flex: 1 },
  //{ field: "processWorkFlow", headerName: "Process Work Flow", flex: 1 },
  //{ field: "email", headerName: "Email", flex: 1 },
];

export const AccountTypesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "accountType", headerName: "Account Type", flex: 1 },
];
export const MajorClassificationColumns = [
  { field: "id", headerName: "ID", flex: 2 },
  { field: "majorClassification", headerName: "MajorClassification", flex: 2 },
  // { field: "company", headerName: "Company", flex: 1 },
];
export const FeeNoteColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "issueDate",
    headerName: "Issue Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },

  {
    field: "clientName",
    headerName: "Client",
    flex: 1,
    valueGetter: (params) =>
      params.row?.clientName ||
      params.row?.client?.fullName ||
      params.row?.client?.companyName ||
      "—",
  },
  { field: "caseNumber", headerName: "File No.", flex: 1 },
  { field: "caseTitle", headerName: "File Name", flex: 1.5 },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: ({ value }) => {
      if (!value) return "-";
      return value.toLocaleString("en-KE", {
        style: "currency",
        currency: "KES",
      });
    },
  },
  {
    field: "balance",
    headerName: "Balance",
    flex: 0.8,
    valueGetter: (params) => {
      const val = params.row.balance;
      return val ?? 0; // if balance is null/undefined, return 0
    },
    valueFormatter: ({ value }) => {
      return value.toLocaleString("en-KE", { style: "currency", currency: "KES" });
    },
  },
  { field: "statusName", headerName: "FileStatus", flex: 0.8 },
];

export const feeNoteLinesColumns = [
  // Add required: true to at least the essential fields
  { field: "id", headerName: "ID", flex: 0.3, required: true }, // Add ID and required: true
  { field: "description", headerName: "Description", flex: 2, required: true }, // Add required: true to Description
  {
    field: "accountSubCategoryName",
    headerName: "Account Subcategory Name",
    flex: 1,
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: ({ value }) => {
      if (!value) return '-';
      return value.toLocaleString('en-KE', { style: 'currency', currency: 'KES' });
    },
  },
  { field: "vatAmount", headerName: "VAT Amount", flex: 1 },
];
export const purchaseInvoiceLinesColumns = [
  // Add required: true to at least the essential fields
  { field: "id", headerName: "ID", flex: 0.3, required: true }, // Add ID and required: true
  { field: "description", headerName: "Description", flex: 2, required: true }, // Add required: true to Description

  // show the account type/subcategory so user can see what was selected
  {
    field: "accountTypeName",
    headerName: "Account Type",
    flex: 1,
    valueGetter: (params) => params.row.accountTypeName || params.row.accountSubCategoryName || "",
  },

  { field: "accountName", headerName: "Account", flex: 1 },

  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: ({ value }) => {
      if (!value) return '-';
      return value.toLocaleString('en-KE', { style: 'currency', currency: 'KES' });
    },
  },
];

export const imprestLinesColumns = [
  // Add required: true to at least the essential fields
  { field: "id", headerName: "ID", flex: 0.3, required: true }, // Add ID and required: true
  { field: "description", headerName: "Description", flex: 2, required: true }, // Add required: true to Description

  { field: "accountId", headerName: "Account", flex: 1 },

  {
    field: "amountRequested",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: ({ value }) => {
      if (!value) return '';
      return value.toLocaleString('en-KE', { style: 'currency', currency: 'KES' });
    },
  },
];
export const ClientReceiptLinesColumns = [
  // Add required: true to at least the essential fields
  { field: "id", headerName: "ID", flex: 0.3, required: true }, // Add ID and required: true
  { field: "description", headerName: "Description", flex: 2, required: true }, // Add required: true to Description
  {
    field: "accountSubCategoryName",
    headerName: "Account Subcategory Name",
    flex: 1,
  },
  { field: "amount", headerName: "Amount", flex: 1 },
];


export const CreditNoteLinesColumns = [
  // Add required: true to at least the essential fields
  { field: "id", headerName: "ID", flex: 0.3, required: true }, // Add ID and required: true
  { field: "description", headerName: "Description", flex: 2, required: true }, // Add required: true to Description
  {
    field: "accountSubCategoryName",
    headerName: "Account Subcategory Name",
    flex: 1,
  },
  { field: "amount", headerName: "Amount", flex: 1 },
  // { field: "vatId", headerName: "VAT ID", flex: 1 },
  //{ field: "vatAmount", headerName: "VAT Amount", flex: 1 },
  //{ field: "isActive", headerName: "Active", flex: 0.5 },

];
export const CreditNoteEntryFormColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "issueDate",
    headerName: "Issue Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  { field: "clientName", headerName: "Client", flex: 1 },
  { field: "caseNumber", headerName: "File No", flex: 1 },
  //{ field: "documentTypeName", headerName: "Document Type", flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: ({ value }) => {
      if (!value) return "";
      return value.toLocaleString("en-KE", {
        style: "currency",
        currency: "KES",
      });
    },
  },
  //{ field: "currency", headerName: "Currency", flex: 0.8 },
  { field: "statusName", headerName: "File Status", flex: 1 },
  {
    field: "dueDate",
    headerName: "Due Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  //{ field: "company", headerName: "Company", flex: 1 },
];

export const ProformaNoteEntryFormColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "issueDate",
    headerName: "Issue Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  {
    field: "clientName",
    headerName: "Client",
    flex: 1.2,
    valueGetter: (params) =>
      params.row?.clientName ||
      params.row?.client?.fullName ||
      params.row?.client?.companyName ||
      "—",
  },
  { field: "caseNumber", headerName: "File No.", flex: 1.5 },
  { field: "caseTitle", headerName: "File Name", flex: 2 },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: ({ value }) => {
      if (!value) return "-";
      return value.toLocaleString("en-KE", {
        style: "currency",
        currency: "KES",
      });
    },
  },
  { field: "statusId", headerName: "FileStatus", flex: 0.8 },
];
export const SuppliersColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "supplierName", headerName: "Supplier Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "contactNumber", headerName: "Contact Number", flex: 0.8 },
  { field: "balance", headerName: "Balance", flex: 0.8 },
  { field: "isActive", headerName: "Status", flex: 0.5 },
];

export const VendorInvoiceColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "supplierName", headerName: "Supplier Name", flex: 1 },
  {
    field: "invoiceNumber",
    headerName: "Invoice Number",
    flex: 1,
    valueGetter: (params) => params.row?.invoiceNumber || "—"
  },
  {
    field: "issueDate",
    headerName: "Issue Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  { field: "totalAmount", headerName: "TotalAmount", flex: 1 },
  {
    field: "balance",
    headerName: "Balance",
    flex: 1,
    valueGetter: (params) => {
      const val = params.row.balance;
      return val ?? 0; // if balance is null/undefined, return 0
    },
    valueFormatter: ({ value }) => {
      return value.toLocaleString("en-KE", { style: "currency", currency: "KES" });
    },
  },
  { field: "statusName", headerName: "Invoice Status", flex: 1 },
];

export const VoucherHeaderColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "voucherNumber",
    headerName: "Voucher Number",
    flex: 1.5,
    valueGetter: (params) => params.row?.voucherNumber || "—"
  },
  // display account type (paymentAccountTypeName) returned by the query
  {
    field: "paymentAccountTypeName",
    headerName: "Account Type",
    flex: 1.5,
    valueGetter: (params) => params.row?.paymentAccountTypeName || ""
  },
  { field: "paymentAccountName", headerName: "Payment Account", flex: 2 },
  { field: "paymentModeName", headerName: "payment Mode", flex: 1.5 },
  // {
  //   field: "voucherDate",
  //   headerName: "Voucher Date",
  //   flex: 1.5,
  //   type: "date",
  //   valueGetter: (params) => {
  //     if (!params.value) return "";
  //     const date = new Date(params.value);
  //     // Format as YYYY-MM-DD
  //     return date.toISOString().split("T")[0];
  //   },
  // },
  {
    field: "voucherDate",
    headerName: "Voucher Date",
    flex: 1.5,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },

  { field: "description", headerName: "Description", type: "string", flex: 2 },
  { field: "totalAmount", headerName: "Total Amount", type: "number", flex: 1.5 },
  {
    field: "isPosted",
    headerName: "Status",
    type: "boolean",
    flex: 1.2,
    renderCell: (params) => {
      const isPosted = params.value;

      return (
        <div
          style={{
            backgroundColor: isPosted ? "#10b981" : "#ef4444",
            color: "white",
            padding: "6px 16px",
            borderRadius: "20px",
            fontWeight: "600",
            fontSize: "12px",
            textAlign: "center",
            display: "inline-block",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {isPosted ? "Posted" : "Pending"}
        </div>
      );
    },
  },
];
export const VoucherLineColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "amount", headerName: "Amount", type: "number", flex: 1 },
  { field: "payeeTypeName", headerName: "Payee Type", type: "string", flex: 1 },
  { field: "payeeName", headerName: "Payee Name", type: "string", flex: 1.5 },
  {
    field: "accountTypeName",
    headerName: "Account Type",
    type: "string",
    flex: 1,
  },
  {
    field: "accountName",
    headerName: "Account",
    type: "string",
    flex: 1,
  },
  { field: "description", headerName: "Description", flex: 2.5 },
  { field: "voucherNumber", headerName: "Voucher Number", flex: 1.5 },
  // { field: "status", headerName: "Status", flex: 1 },
];
export const MinorClassificationColumns = [
  { field: "id", headerName: "ID", flex: 2 },
  { field: "minorClassification", headerName: "Minor Classification", flex: 2 },
  // { field: "company", headerName: "Company", flex: 1 },
];
export const ReportTypesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "majorClassification", headerName: "Major Classification", flex: 1 },
  { field: "minorClassification", headerName: "Minor Classification", flex: 1 },
  { field: "reportName", headerName: "Report Name", flex: 1 },
];
export const ReportBrowserColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "module", headerName: "Module", flex: 1 },
  { field: "company", headerName: "Company", flex: 1 },
];

export const FileProgressColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "actionDate",
    headerName: "Activity Date",
    flex: 1,
    renderCell: (params) =>
      params.value ? format(new Date(params.value), "dd-MMM-yyyy") : "N/A",
  },
  { field: "actionTypeName", headerName: "Activity Type", flex: 1.5 },
  { field: "actionTaken", headerName: "Description / Action Taken", flex: 2.5 },
  { field: "remarks", headerName: "Remarks", flex: 2 },
  {
    field: "nextBringUpDate",
    headerName: "Next Bring Up",
    flex: 1,
    renderCell: (params) =>
      params.value ? format(new Date(params.value), "dd-MMM-yyyy") : "N/A",
  },
  { field: "status", headerName: "Status", flex: 1 },
];

export const SafeDocumentsColumns = [
  { field: "docNo", headerName: "Doc No", flex: 0.5 },
  { field: "registeredBy", headerName: "Registered By", flex: 1 },
  { field: "client", headerName: "Client", flex: 1 },
  { field: "fileNo", headerName: "File No", flex: 1 },
  { field: "fileName", headerName: "File Name", flex: 1 },
  { field: "docType", headerName: "Doc Type", flex: 1 },
  { field: "document", headerName: "Document", flex: 1 },
  { field: "givenBy", headerName: "Given By", flex: 1 },
  { field: "returnDate", headerName: "Return Date", flex: 1 },
  { field: "approver", headerName: "Approver", flex: 1 },
  { field: "status", headerName: "Status", flex: 1 },
];

export const CourtEventTypeColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "eventType", headerName: "Event Type", flex: 1.5 },
  {
    field: "isActive",
    headerName: "Status",
    flex: 0.5,
    type: "boolean",
    renderCell: ({ value }) => (
      <Box
        p="0 10px"
        borderRadius="4px"
        backgroundColor={value ? "#4ade80" : "#f87171"}
        color="white"
        textAlign="center"
      >
        <Typography variant="body2" fontWeight="bold">
          {value ? "Active" : "Inactive"}
        </Typography>
      </Box>
    ),
  },
  { field: "createdBy", headerName: "Created By", flex: 1 },
  {
    field: "createdDate",
    headerName: "Created Date",
    flex: 1,
    type: "dateTime",
  },
  { field: "updatedBy", headerName: "Updated By", flex: 1 },
  {
    field: "updatedDate",
    headerName: "Updated Date",
    flex: 1,
    type: "dateTime",
  },
];

export const FixedAssetsCategoriesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "categoryName", headerName: "Category Name", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  //{ field: "status", headerName: "Status", flex: 1 },

];

export const AssetTypesColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  //{ field: "categoryId", headerName: "Category Id", flex: 1 },
  { field: "typeName", headerName: "Type Name", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
];

export const DepreciationMethodsColumns = [
  { field: "id", headerName: " ID", flex: 0.3 },
  { field: "methodName", headerName: "method Name", flex: 1 },
  { field: "description", headerName: "Description", flex: 2 },
];

export const DepreciationSchedulesColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "categoryName", headerName: "Category Name", flex: 1.5 },
  { field: "assetTypeName", headerName: "Type Name", flex: 1 },
  { field: "depreciationMethodName", headerName: "Method Name", flex: 1.5 },
  { field: "usefulLifeYears", headerName: "Useful Life Years", flex: 1 },
  {
    field: "salvageValue",
    headerName: "Salvage Value",
    flex: 1,
    renderCell: (params) =>
      params.value != null && params.value !== ""
        ? Number(params.value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : "-",
  },
];

export const getFixedAssetsColumns = (categories, types, methods, schedules) => [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "assetCode", headerName: "Asset Code", flex: 1 },
  { field: "assetName", headerName: "Asset Name", flex: 1 },
  {
    field: "categoryId",
    headerName: "Category",
    flex: 1,
    valueGetter: (params) => {
      const cat = categories?.find((c) => c.id === params.row.categoryId);
      return cat ? cat.categoryName : params.row.categoryName || "-";
    },
  },
  {
    field: "typeId",
    headerName: "Type",
    flex: 1,
    valueGetter: (params) => {
      const t = types?.find((type) => type.id === params.row.typeId);
      return t ? t.typeName : params.row.typeName || "-";
    },
  },
  {
    field: "purchaseCost",
    headerName: "Purchase Cost",
    flex: 1,
    renderCell: (params) =>
      params.value != null && params.value !== ""
        ? Number(params.value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : "-",
  },
  {
    field: "currentValue",
    headerName: "Current Value",
    flex: 1,
    renderCell: (params) =>
      params.value != null && params.value !== ""
        ? Number(params.value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : "-",
  },
  { field: "location", headerName: "Location", flex: 1 },
  { field: "department", headerName: "Department", flex: 1 },
  { field: "custodian", headerName: "Custodian", flex: 1 },
  { field: "status", headerName: "Status", flex: 1 },
];
